import React from "react";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => {
  return (
    <>
      <div className="d-flex flex-column flex-lg-row">
        <div className="dashboard-sidebar">
          <Sidebar />
        </div>
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default Layout;
